import { useEffect, useReducer, useState } from 'react'
import stateReducer from "./reducers";
import stateActions from "./actions";
import { initialState } from "./reducers"
import { getStateFromStorage } from './storage';

export default function useStateManager() {
  useEffect(() => {
    const loadStore = async () => {
      const state = await getStateFromStorage()
      actions.updateStateFromStorage(state || initialState)
      // actions.updateStoredProgress(state?.arenas ? state.arenas : initialState.arenas)
    }
    loadStore()
  },[])
  const [state, stateDispatch] = useReducer(stateReducer, initialState);
  const actions = stateActions(stateDispatch);
  
  return {
    state,
    ...actions,
  };
}
